import React, { Component } from 'react';
import PropTypes from 'prop-types';

import utils from '@utils/index';
import MAP_CONSTANTS from '../../../constants/map.json';

import styles from './index.module.css';

import iconWhite from './images/iconWhite.svg';
import icon from './images/icon.svg';
import iconYellow from './images/iconYellow.svg';
import iconGreen from './images/iconGreen.svg';

const CONTAINER_WIDTH_DEFAULT = 320 * 2;
const CONTAINER_HEIGHT_DEFAULT = 200 * 2;

const MAP_VIEW_SIZE_DEFAULT = {
  width: MAP_CONSTANTS.main.width,
  height: MAP_CONSTANTS.main.height,
};

utils.preloadImages([icon, iconWhite, iconYellow, iconGreen]);

/*
function HighlightArea({ zoom }) {

  let { coords, txtScale } = Map.getTagCoordinates(location.x, location.y, location.name, zoom * 0.2);
  let fontSize = txtScale * 14 * props.mapDimensions.width / innerLayerWidth;

  return <g key={idx} className={props.curLocation === location.name || idx === this.state.hoveredArea ? styles.areaVisible : styles.area}><polygon
    className={`${styles.historyArea} ${props.curLocation === location.name ? styles.areaRectFullyVisible : idx === this.state.hoveredArea ? styles.areaRectDim : ''}`}
    onMouseEnter={this._showAreaByIdx[idx + 1]}
    onMouseLeave={this._showAreaByIdx[0]}
    onClick={() => { props.setLocation(location.name); }}//todo: look into it
    points={`${location.x.map((xCoord, i) => xCoord + ',' + (this.mapDimensions.height - location.y[i])).join(' ')}`} />
    {this.textBorders[idx] && <rect
      className={`${styles.areaLabelBackground} ${props.curLocation === location.name ? styles.area : ''}`}
      x={this.textBorders[idx].x}
      y={this.textBorders[idx].y}
      width={this.textBorders[idx].width}
      height={this.textBorders[idx].height} />}
    <text ref={this.areaLabelsRefs[idx]} x={coords[0]} y={coords[1] + fontSize} style={{ fontSize: fontSize + 'px' }} className={`${styles.areaLabel} ${props.curLocation === location.name ? styles.area : ''}`}>{locations[idx].displayName}</text></g>

}*/

class MarkGroup extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.amount !== this.props.amount ||
      nextProps.zoom !== this.props.zoom ||
      nextProps.containerRef !== this.props.containerRef;
  }

  render() {
    const props = this.props;

    return props.marks.map((mark, idx) => {
      const x =
        (props.innerLayerWidth * mark.x) / props.mapWidth;
      const y =
        (props.innerLayerHeight *
        (props.mapHeight - mark.y)) /
        props.mapHeight;
      return (
        <Mark
          key={idx}
          hoverDataGetter={(x, y) => utils
                  .multilineTextToArray(props.getTestData(x, y))
                  .map((subTxt, jdx) => (
                    <div key={jdx}>{subTxt}</div>
                  ))}
          type='red'
          containerRef={props.containerRef}
          zoom={props.zoom}
          testX={mark.x}
          testY={mark.y}
          x={x}
          y={y}
          />
      );
    })
  }
}

MarkGroup.propTypes = {
  amount: PropTypes.number.isRequired,
  marks: PropTypes.array.isRequired,
  getTestData: PropTypes.func.isRequired,
  zoom: PropTypes.number.isRequired,
  innerLayerWidth: PropTypes.number.isRequired,
  innerLayerHeight: PropTypes.number.isRequired,
  containerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  mapWidth: PropTypes.number.isRequired,
  mapHeight: PropTypes.number.isRequired
};


class RedDot extends Component {
  constructor(props) {
    super(props);

    this.state = {
      curStep: -1,
    };
    this.latestTransformCoords =
      props.coords.length > 0 ? props.coords[0] : { x: 0, y: 0 };

    this.transitionEnd = () => {
      this.nextStep();
    };
  }

  nextStep() {
    let props = this.props;
    let nextStep = this.state.curStep + 1;
    if (nextStep >= this.props.coords.length) {
      nextStep = -1;
    }
    if (nextStep === -1) {
      this.latestTransformCoords = props.coords[props.coords.length - 1];
    } else if (nextStep === 0) {
      //this.latestTransformCoords = props.coords[0];//prevProps.coords[prevProps.coords.length - 1];
    } else {
      this.latestTransformCoords = props.coords[nextStep]; //props.coords[this.state.curStep - 1];
    }
    this.setState({
      curStep: nextStep,
    });
  }

  updateArrayCondition(props, nextProps) {
    return (
      props.coords.length !== nextProps.coords.length ||
      !props.coords.every(function(value, index) {
        return (
          value.x === nextProps.coords[index].x &&
          value.y === nextProps.coords[index].y
        );
      })
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.curStep !== nextState.curStep ||
      this.updateArrayCondition(this.props, nextProps)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    let props = this.props;
    if (this.updateArrayCondition(prevProps, this.props)) {
      //this.latestTransformCoords = prevProps.coords[prevProps.coords.length - 1];
      this.latestTransformCoords = props.coords[0];
      this.setState({ curStep: 0 });
    } else if (prevState.curStep !== this.state.curStep) {
      /*if (this.state.curStep === -1) {
        this.latestTransformCoords = props.coords[props.coords.length - 1];
      } else if (this.state.curStep === 0) {
        this.latestTransformCoords = props.coords[0];//prevProps.coords[prevProps.coords.length - 1];
      } else {
        this.latestTransformCoords = props.coords[this.state.curStep];//props.coords[this.state.curStep - 1];
      }*/
    }
  }

  render() {
    return (
      <div
        className={styles.outer}
        style={{
          transform: `translate(${this.latestTransformCoords.x}px, ${
            this.latestTransformCoords.y
          }px)`,
        }}
        onTransitionEnd={this.transitionEnd}>
        <div className={styles.red_dot} />
      </div>
    );
  }
}

function SimpleMark(props) {
  const size = props.zoom
    ? props.zoom > 1
      ? props.zoom > 3
        ? 'lg'
        : 'md'
      : 'sm'
    : 'md';
  return (
    <div
      className={`${styles.icon} ${styles.icon_simple} ${styles[props.type]} ${
        styles['icon_' + size]
      }`}
      style={{
        left: props.x,
        top: props.y,
      }}
    />
  );
}

class Mark extends Component {
  constructor(props) {
    super(props);
    this.state = { tooltipShown: false, tooltipLeft: false, tooltipTop: false };

    this.popupRef = React.createRef();
    this.mainRef = React.createRef();

    this.hoverData = '';

    this.showPopup = () => {
      this.hoverData = props.hoverDataGetter(props.testX, props.testY);
      this.setState({ tooltipShown: true }, () => {
        const BCRMark = this.mainRef.current.getBoundingClientRect();
        const BCROuterContainer = this.mainRef.current.offsetParent.parentElement.getBoundingClientRect();
        let leftOffset = BCRMark.left - BCROuterContainer.left; //this.mainRef.current.offsetLeft;
        let topOffset = BCRMark.top - BCROuterContainer.top; //this.mainRef.current.offsetTop;
        let BCR = this.popupRef.current.getBoundingClientRect();
        let width = BCR.width;
        let height = BCR.height;
        let leftHand =
          props.containerRef.current.getBoundingClientRect().width -
            leftOffset -
            this.mainRef.current.offsetWidth <=
          width;
        let onTop =
          props.containerRef.current.getBoundingClientRect().height -
            topOffset -
            this.mainRef.current.offsetHeight <=
          height;

        this.setState({ tooltipLeft: leftHand, tooltipTop: onTop });
      });
    };
    this.hidePopup = () => {
      this.setState({ tooltipShown: false });
    };
  }
  render() {
    let props = this.props;
    const size = props.zoom > 1 ? (props.zoom > 3 ? 'lg' : 'md') : 'sm';
    return (
      <React.Fragment>
        <div
          ref={this.mainRef}
          className={`${styles.icon} ${styles[props.type]} ${
            styles['icon_' + size]
          }`}
          onMouseEnter={this.showPopup}
          onMouseLeave={this.hidePopup}
          style={{
            left: props.x,
            top: props.y,
          }}>
          {this.state.tooltipShown && (
            <div
              ref={this.popupRef}
              className={`${styles.popup}
           ${this.state.tooltipLeft && styles.left}
           ${this.state.tooltipTop && styles.top}`}>
              {this.hoverData}
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

/*
 * locations - Array of objects of the form {
 *   x,
 *   y,
 *   name,
 *   displayName
 * }
 * */
function MapBound(locations) {
  class Map extends Component {
    constructor(props) {
      super(props);

      //zoom: 0.2, 0.5, 1
      /*this.state = {
       zoom: 1
       };*/
      this.state = {
        status: true,
        startPos: { x: 0, y: 0 },
        lastPos: { x: 0, y: 0 },
        relPos: { x: 0, y: 0 },
        outerPos: { x: 0, y: 0 },
        hoveredArea: -1,
      };

      this.containerWidth = props.width;
      this.containerHeight = props.height;
      this.mapDimensions = props.mapDimensions;
      this.coordsStep = props.coordsStep;

      let locationsTemplate = Array.apply(null, Array(locations.length + 1));

      this.containerRef = React.createRef();
      this.mapLayerRef = React.createRef();
      this.areaLabelsRefs = locationsTemplate.map(() => React.createRef());

      this.textBorders = [];

      this._onMouseUp = this._onMouseUp.bind(this);
      this._onMouseMove = this._onMouseMove.bind(this);
      this._onMouseDown = this._onMouseDown.bind(this);
      this._onLayerHover = this._onLayerHover.bind(this);
      this._onMouseOut = this._onMouseOut.bind(this);

      this._showAreaByIdx = locationsTemplate.map((v, idx) =>
        this._showArea.bind(this, idx - 1),
      );

      this._onPickingModeClick = this._onPickingModeClick.bind(this);
    }

    _onMouseDown(event) {
      const box = this.mapLayerRef.current.getBoundingClientRect();

      event.preventDefault();
      // event.stopPropagation();
      if (this.props.zoom <= 1) {
        return;
      }

      const cursorPosition = utils.getCursorPosition(event);
      document.addEventListener(utils.events.mousemove, this._onMouseMove, {
        passive: false,
      });
      document.addEventListener(utils.events.mouseup, this._onMouseUp, {
        passive: false,
      });

      this.setState({
        status: true,
        startPos: { x: cursorPosition.cx, y: cursorPosition.cy },
        lastPos: {
          x: this.state.relPos.x * box.width,
          y: this.state.relPos.y * box.height,
        },
        outerPos: { x: 0, y: 0 },
      });

      return false;
    }

    removeEventHandlers() {
      document.removeEventListener(
        utils.events.mousemove,
        this._onMouseMove,
        false,
      );
      document.removeEventListener(
        utils.events.mouseup,
        this._onMouseUp,
        false,
      );
    }

    static snapToSegment(n1, n2, maxDist) {
      if (n1 === n2) return n2;
      let delta = n2 - n1;
      let dist = Math.abs(delta);
      if (dist > maxDist) {
        return n1 + (delta / dist) * maxDist;
      } else {
        return n2;
      }
    }

    static restrictCrosshair(x1, y1, x2, y2, maxDistance) {
      if (x1 === x2 && y1 === y2) return { x: x1, y: y1 };
      let deltaX = x2 - x1;
      let deltaY = y2 - y1;
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        return { x: Map.snapToSegment(x1, x2, maxDistance), y: y1 };
      } else {
        return { x: x1, y: Map.snapToSegment(y1, y2, maxDistance) };
      }
    }

    _onLayerHover(event) {
      const box = this.containerRef.current.getBoundingClientRect();
      const pos = utils.getCursorPosition(event);
      const coords = {
        x:
          Math.round(
            ((-this.state.relPos.x +
              (pos.cx - box.left) / (this.props.zoom * box.width)) *
              this.mapDimensions.width) /
              this.coordsStep
          ) * this.coordsStep,
        y:
          Math.round(
            ((1 +
              this.state.relPos.y -
              (pos.cy - box.top) / (this.props.zoom * box.height)) *
              this.mapDimensions.height) /
              this.coordsStep
          ) * this.coordsStep,
      };
      if (coords.x === this.mapDimensions.width) coords.x -= this.coordsStep;
      if (coords.y === this.mapDimensions.height) coords.y -= this.coordsStep;
      this.props.onCoordsChange(coords);
      let newCoords = { x: coords.x, y: coords.y };
      if (this.props.activeTest === 'srr' || this.props.activeTest === 'gpr') {
        if (this.props.settingCrosshairs === 1) {
          newCoords = Map.restrictCrosshair(
            this.props.crosshairs[0].x,
            this.props.crosshairs[0].y,
            coords.x,
            coords.y,
            MAP_CONSTANTS.markerParams[this.props.activeTest + 'MaxDistance'],
          );
        }
      }

      this.props.onCrosshairMove(newCoords);
    }

    _onMouseOut() {
      this.props.onCoordsChange({ x: -1, y: -1 });
      this.props.onCrosshairMove({ x: -1, y: -1 });
    }

    _onMouseMove(event) {
      const box = this.mapLayerRef.current.getBoundingClientRect();
      event.preventDefault();
      event.stopPropagation();

      if (!this.state.status) {
        return false;
      }

      const cursorPosition = utils.getCursorPosition(event);
      const transformX =
        (cursorPosition.cx - this.state.startPos.x + this.state.lastPos.x) /
        box.width;
      const transformY =
        (cursorPosition.cy - this.state.startPos.y + this.state.lastPos.y) /
        box.height;

      this.setState(state => ({
        relPos: { x: transformX, y: transformY },
      }));

      this.props.onGlide({ x: -transformX, y: -transformY });

      return false;
    }

    _onMouseUp(event) {
      event.preventDefault();

      if (this.state.status) {
        this.setState({ status: false });
        this.removeEventHandlers();
      }
    }

    static getTagCoordinates(xCoords, yCoords, locationName, zoomLevel) {
      // zoomLevel values: 0.2, 0.5, 1
      let coords = [xCoords[xCoords.length - 1], yCoords[xCoords.length - 1]];
      coords[0] = coords[0] + 20;
      coords[1] = 2000 - (coords[1] + 84);
      switch (locationName) {
        case 'waterTower':
          if (zoomLevel === 1) {
            coords[0] = coords[0] + 35;
          } else if (zoomLevel === 0.5) {
            coords[0] = coords[0] + 45;
          } else {
            coords[0] = coords[0] + 70;
          }
          break;

        case 'muniGovt':
          if (zoomLevel === 1) {
            coords[0] = coords[0] + 75;
          } else if (zoomLevel === 0.5) {
            coords[0] = coords[0] + 85;
          } else {
            coords[0] = coords[0] + 100;
          }
          break;

        case 'townWell':
          if (zoomLevel === 1) {
            coords[0] = coords[0] - 18;
            coords[1] = coords[1] - 20;
          } else if (zoomLevel === 0.5) {
            coords[0] = coords[0] - 57;
            coords[1] = coords[1] - 40;
          } else {
            coords[0] = coords[0] - 120;
            coords[1] = coords[1] - 80;
          }
          break;

        case 'btex':
          if (zoomLevel === 1) {
            coords[0] = coords[0] - 140;
          } else if (zoomLevel === 0.5) {
            coords[0] = coords[0] - 240;
          } else {
            coords[0] = coords[0] - 480;
          }
          break;

        case 'tillies':
          if (zoomLevel === 1) {
            coords[0] = coords[0] - 180;
            coords[1] = coords[1] - 90;
          } else if (zoomLevel === 0.5) {
            coords[0] = coords[0] - 330;
            coords[1] = coords[1] - 110;
          } else {
            coords[0] = coords[0] - 600;
            coords[1] = coords[1] - 130;
          }
          break;

        case 'firnFreeze':
          if (zoomLevel === 1) {
            coords[0] = coords[0] - 180;
            coords[1] = coords[1] + 60;
          } else if (zoomLevel === 0.5) {
            coords[0] = coords[0] - 187;
            coords[1] = coords[1] + 90;
          } else {
            coords[0] = coords[0] - 260;
            coords[1] = coords[1] + 90;
          }
          break;

        case 'kilroys':
          if (zoomLevel === 1) {
            coords[0] = coords[0] - 10;
            coords[1] = coords[1] + 60;
          } else if (zoomLevel === 0.5) {
            coords[0] = coords[0] - 15;
            coords[1] = coords[1] + 45;
          } else {
            coords[0] = coords[0] - 60;
            coords[1] = coords[1] - 150;
          }
          break;

        case 'kameKondos':
          if (zoomLevel === 1) {
            coords[0] = coords[0] - 10;
            coords[1] = coords[1] - 425;
          } else if (zoomLevel === 0.5) {
            coords[0] = coords[0] - 70;
            coords[1] = coords[1] - 440;
          } else {
            coords[0] = coords[0] - 235;
            coords[1] = coords[1] - 480;
          }
          break;

        case 'fourHomes':
          if (zoomLevel === 1) {
            coords[0] = coords[0] - 170;
            coords[1] = coords[1] - 330;
          } else if (zoomLevel === 0.5) {
            coords[0] = coords[0] - 300;
            coords[1] = coords[1] - 345;
          } else {
            coords[0] = coords[0] - 580;
            coords[1] = coords[1] - 380;
          }
          break;
        default:
          if (zoomLevel === 1) {
            coords[1] = coords[1] + 50;
            break;
          }
          if (zoomLevel === 0.5) {
            coords[1] = coords[1] + 35;
          }
      }

      let txtScale = 1.1;
      if (zoomLevel === 1) {
        txtScale = 1.6;
      } else if (zoomLevel === 0.5) {
        txtScale = 1.25;
      }

      return { coords, txtScale };
    }

    _showArea(idx) {
      if (idx > -1 && !this.textBorders[idx]) {
        let box = this.areaLabelsRefs[idx].current.getBBox();
        this.textBorders[idx] = {
          x: box.x - 2,
          y: box.y - 2,
          width: box.width + 4,
          height: box.height + 4,
        };
      }
      this.setState({ hoveredArea: idx });
    }

    componentDidMount() {
      this.mapLayerRef.current.addEventListener(
        utils.events.mousedown,
        this._onMouseDown,
        { passive: false },
      );
      this.mapLayerRef.current.addEventListener(
        utils.events.mousemove,
        this._onLayerHover,
        { passive: false },
      );
      this.mapLayerRef.current.addEventListener(
        utils.events.mouseout,
        this._onMouseOut,
        { passive: false },
      );
    }

    componentWillUnmount() {
      this.mapLayerRef.current.removeEventListener(
        utils.events.mousedown,
        this._onMouseDown,
      );
      this.mapLayerRef.current.removeEventListener(
        utils.events.mousemove,
        this._onLayerHover,
      );
      this.mapLayerRef.current.removeEventListener(
        utils.events.mouseout,
        this._onMouseOut,
      );
    }

    componentDidUpdate(prevProps, prevState) {
      if (
        -prevState.relPos.x !== this.props.offset.x ||
        -prevState.relPos.y !== this.props.offset.y
      ) {
        this.setState({
          relPos: {
            x: -this.props.offset.x,
            y: -this.props.offset.y,
          },
          outerPos: {
            x: this.props.offset.x,
            y: this.props.offset.y,
          },
        });
      }

      if (
        prevProps.settingCrosshairs === -1 &&
        this.props.settingCrosshairs > -1
      ) {
        this.turnOnCrosshairMode();
      } else if (
        this.props.settingCrosshairs === -1 &&
        prevProps.settingCrosshairs > -1
      ) {
        this.turnOffCrosshairMode();
      }

      if (prevProps.zoom !== this.props.zoom) {
        for (let i = 0; i < this.textBorders.length; i++) {
          this.textBorders[i] = null;
        }
      }
    }

    _onPickingModeClick(event) {
      let target = null;

      event.preventDefault();

      if (event.touches && event.touches[0]) {
        target = event.touches[0].target;
      } else if (event.changedTouches && event.changedTouches[0]) {
        target = event.changedTouches[0].target;
      } else {
        target = event.target;
      }

      if (
        target === this.mapLayerRef.current ||
        event.target.className.indexOf(styles.icon) > -1
      ) {
        const box = this.containerRef.current.getBoundingClientRect();
        const pos = utils.getCursorPosition(event);
        const coords = {
          x:
            Math.round(
              ((-this.state.relPos.x +
                (pos.cx - box.left) / (this.props.zoom * box.width)) *
                this.mapDimensions.width) /
                this.coordsStep,
            ) * this.coordsStep,
          y:
            Math.round(
              ((1 +
                this.state.relPos.y -
                (pos.cy - box.top) / (this.props.zoom * box.height)) *
                this.mapDimensions.height) /
                this.coordsStep,
            ) * this.coordsStep,
        };
        if (coords.x === this.mapDimensions.width) coords.x -= this.coordsStep;
        if (coords.y === this.mapDimensions.height) coords.y -= this.coordsStep;

        this.props.onCoordsChange(coords);
        let newCoords = { x: coords.x, y: coords.y };
        if (
          this.props.activeTest === 'srr' ||
          this.props.activeTest === 'gpr'
        ) {
          if (this.props.settingCrosshairs === 1) {
            newCoords = Map.restrictCrosshair(
              this.props.crosshairs[0].x,
              this.props.crosshairs[0].y,
              coords.x,
              coords.y,
              MAP_CONSTANTS.markerParams[this.props.activeTest + 'MaxDistance'],
            );
          }
        }

        this.props.onCrosshairSetup(newCoords);
      } else {
        this.props.onCrosshairCancel();
      }

      return false;
    }

    turnOnCrosshairMode() {
      document.addEventListener(
        utils.events.mousedown,
        this._onPickingModeClick,
        { passive: false },
      );
    }

    turnOffCrosshairMode() {
      document.removeEventListener(
        utils.events.mousedown,
        this._onPickingModeClick,
        { passive: false },
      );
    }

    render() {
      const props = this.props;
      const zoom = this.props.zoom;
      const innerLayerWidth = this.containerWidth * zoom;
      const innerLayerHeight = this.containerHeight * zoom;
      const transformX = -props.offset.x * innerLayerWidth;
      const transformY = -props.offset.y * innerLayerHeight;
      const innerLayerStyle = {
        width: innerLayerWidth,
        height: innerLayerHeight,
        backgroundImage: `url(${props.bitmap})`,
        transform: `translate(${transformX}px, ${transformY}px)`,
      };
      let marks = props.activeTest ? props.getMarks(props.activeTest) : [];

      return (
        <div
          ref={this.containerRef}
          className={styles.container_outer}
          style={{ width: this.containerWidth, height: this.containerHeight }}>
          <div
            ref={this.mapLayerRef}
            style={innerLayerStyle}
            className={`${styles.container_inner} ${
              props.settingCrosshairs > -1 ? styles.cursor_picking_first : ''
            }`}>
            {props.curMode === 1 && (
              <svg
                xmlnsXlink='http://www.w3.org/1999/xlink'
                xmlns='http://www.w3.org/2000/svg'
                version='1.1'
                width='100%'
                height='100%'
                viewBox={`0 0 ${props.mapDimensions.width} ${
                  props.mapDimensions.height
                }`}>
                {locations.map((location, idx) => (
                  <g
                    key={'area' + idx}
                    className={
                      props.curLocation === location.name ||
                      idx === this.state.hoveredArea
                        ? styles.areaVisible
                        : styles.area
                    }>
                    <polygon
                      className={`${styles.historyArea} ${
                        props.curLocation === location.name
                          ? styles.areaRectFullyVisible
                          : idx === this.state.hoveredArea
                          ? styles.areaRectDim
                          : ''
                      }`}
                      onMouseEnter={this._showAreaByIdx[idx + 1]}
                      onMouseLeave={this._showAreaByIdx[0]}
                      pointerEvents='all'
                      onTouchStart={props.setLocation.bind(null, location.name)}
                      onClick={props.setLocation.bind(null, location.name)} //todo: look into it
                      points={`${location.x
                        .map(
                          (xCoord, i) =>
                            xCoord +
                            ',' +
                            (this.mapDimensions.height - location.y[i]),
                        )
                        .join(' ')}`}
                    />
                  </g>
                ))}
                {locations.map((location, idx) => {
                  let { coords, txtScale } = Map.getTagCoordinates(
                    location.x,
                    location.y,
                    location.name,
                    zoom * 0.2,
                  );
                  let fontSize =
                    (txtScale * 14 * props.mapDimensions.width) /
                    innerLayerWidth;

                  return (
                    <g
                      key={'text' + idx}
                      className={
                        props.curLocation === location.name ||
                        idx === this.state.hoveredArea
                          ? styles.areaVisible
                          : styles.area
                      }>
                      {this.textBorders[idx] && (
                        <rect
                          className={`${styles.areaLabelBackground} ${
                            props.curLocation === location.name
                              ? styles.area
                              : ''
                          }`}
                          x={this.textBorders[idx].x}
                          y={this.textBorders[idx].y}
                          width={this.textBorders[idx].width}
                          height={this.textBorders[idx].height}
                        />
                      )}
                      <text
                        ref={this.areaLabelsRefs[idx]}
                        x={coords[0]}
                        y={coords[1] + fontSize}
                        style={{ fontSize: fontSize + 'px' }}
                        className={`${styles.areaLabel} ${
                          props.curLocation === location.name ? styles.area : ''
                        }`}>
                        {locations[idx].displayName}
                      </text>
                    </g>
                  );
                })}
              </svg>
            )}
            {props.visReconCoords.length > 0 && (
              <RedDot
                coords={props.visReconCoords.map(val => ({
                  x: (innerLayerStyle.width * val.x) / this.mapDimensions.width,
                  y:
                    (innerLayerStyle.height * val.y) /
                    this.mapDimensions.height,
                }))}
              />
            )}
            {<MarkGroup amount={marks.length}
                        marks={marks}
                        getTestData={props.getTestData}
                        zoom={zoom}
                        innerLayerWidth={innerLayerWidth}
                        innerLayerHeight={innerLayerHeight}
                        containerRef={this.containerRef}
                        mapWidth={this.mapDimensions.width}
                        mapHeight={this.mapDimensions.height}/>}
            {props.settingCrosshairs > -1 && props.crosshairPicking.x > -1 && (
              <SimpleMark
                zoom={zoom}
                type='white'
                x={
                  (innerLayerStyle.width * props.crosshairPicking.x) /
                  this.mapDimensions.width
                }
                y={
                  (innerLayerStyle.height *
                    (this.mapDimensions.height - props.crosshairPicking.y)) /
                  this.mapDimensions.height
                }
              />
            )}
            {props.crosshairs[0].x > -1 && (
              <SimpleMark
                zoom={zoom}
                type='yellow'
                x={
                  (innerLayerStyle.width * props.crosshairs[0].x) /
                  this.mapDimensions.width
                }
                y={
                  (innerLayerStyle.height *
                    (this.mapDimensions.height - props.crosshairs[0].y)) /
                  this.mapDimensions.height
                }
              />
            )}
            {props.crosshairs[1].x > -1 && (
              <SimpleMark
                zoom={zoom}
                type='green'
                x={
                  (innerLayerStyle.width * props.crosshairs[1].x) /
                  this.mapDimensions.width
                }
                y={
                  (innerLayerStyle.height *
                    (this.mapDimensions.height - props.crosshairs[1].y)) /
                  this.mapDimensions.height
                }
              />
            )}
          </div>
        </div>
      );
    }
  }

  Map.defaultProps = {
    coordsStep: 1,
    width: CONTAINER_WIDTH_DEFAULT,
    height: CONTAINER_HEIGHT_DEFAULT,
    mapDimensions: MAP_VIEW_SIZE_DEFAULT,
    visReconCoords: [],
    curMode: -1,
  };

  Map.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    coordsStep: PropTypes.number,
    mapDimensions: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    offset: PropTypes.object,
    onGlide: PropTypes.func.isRequired,
    bitmap: PropTypes.string.isRequired,
    onCoordsChange: PropTypes.func.isRequired,
    markCount: PropTypes.number.isRequired,
    activeTest: PropTypes.string.isRequired,
    getMarks: PropTypes.func.isRequired,
    getTestData: PropTypes.func.isRequired,
    settingCrosshairs: PropTypes.number,
    crosshairs: PropTypes.array,
    onCrosshairSetup: PropTypes.func,
    onCrosshairMove: PropTypes.func,
    onCrosshairCancel: PropTypes.func,
    crosshairPicking: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
    }),
    visReconCoords: PropTypes.array,
    curMode: PropTypes.number,
    curLocation: PropTypes.string,
    setLocation: PropTypes.func,
  };

  return Map;
}

export default MapBound;
